import React from "react";
import { Spinner } from "reactstrap";
import moment from "moment";

const PersonalInfoCard = ({
  user,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  isEditingPersonal,
  setIsEditingPersonal,
  personalSaveLoader,
  handleSavePersonalInfo,
  biography,
  setBiography,
}) => {
  const memberSince = user?.created_at?.seconds
    ? moment.unix(user.created_at.seconds).format("DD MMM YYYY")
    : "N/A";

  return (
    <div className="saas-card">
      <div className="card-header-saas">
        <h3>Personal Information</h3>
        {!isEditingPersonal ? (
          <button
            className="saas-btn secondary sm"
            onClick={() => setIsEditingPersonal(true)}
          >
            Edit
          </button>
        ) : (
          <div style={{ display: "flex", gap: "8px" }}>
            <button
              className="saas-btn primary sm"
              onClick={handleSavePersonalInfo}
              disabled={
                personalSaveLoader ||
                (firstName === user?.first_name &&
                  lastName === user?.last_name &&
                  biography === (user?.biography || ""))
              }
            >
              {personalSaveLoader ? <Spinner size="sm" /> : "Save"}
            </button>
            <button
              className="saas-btn secondary sm"
              onClick={() => {
                setFirstName(user?.first_name || "");
                setLastName(user?.last_name || "");
                setBiography(user?.biography || "");
                setIsEditingPersonal(false);
              }}
              disabled={personalSaveLoader}
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      <div className="info-field-group">
        {/* First Name */}
        <div className="info-row">
          <span className="info-label">First Name</span>
          {isEditingPersonal ? (
            <input
              required
              className="saas-input"
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              style={{ width: "60%", height: "32px", borderRadius: "6px", fontSize: "0.8125rem" }}
            />
          ) : (
            <span className="info-value">{user?.first_name || "N/A"}</span>
          )}
        </div>

        {/* Last Name */}
        <div className="info-row">
          <span className="info-label">Last Name</span>
          {isEditingPersonal ? (
            <input
              required
              className="saas-input"
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              style={{ width: "60%", height: "32px", borderRadius: "6px", fontSize: "0.8125rem" }}
            />
          ) : (
            <span className="info-value">{user?.last_name || "N/A"}</span>
          )}
        </div>

        {/* Biography */}
        <div className="info-row">
          <span className="info-label">
            Biography *
            {isEditingPersonal && (
              <span className="text-muted d-block font-weight-500" style={{ fontSize: "10px", marginTop: "2px" }}>
                {biography?.length || 0}/250
              </span>
            )}
          </span>
          {isEditingPersonal ? (
            <textarea
              required
              className="saas-input biography-textarea"
              value={biography}
              onChange={(e) => setBiography(e.target.value.substring(0, 250))}
              placeholder="Tell your fans about yourself..."
              maxLength={250}
              style={{
                height: "60px",
                borderRadius: "6px",
                fontSize: "0.8125rem",
                padding: "6px",
                resize: "vertical",
              }}
            />
          ) : (
            <span className="info-value" style={{ fontStyle: user?.biography ? "normal" : "italic", color: user?.biography ? "inherit" : "#94a3b8" }}>
              {user?.biography || "No biography added yet"}
            </span>
          )}
        </div>

        {/* Email */}
        <div className="info-row" style={{ opacity: isEditingPersonal ? 0.6 : 1 }}>
          <span className="info-label">Email ID</span>
          <span className="info-value">{user?.email}</span>
        </div>

        {/* Gender */}
        <div className="info-row" style={{ opacity: isEditingPersonal ? 0.6 : 1 }}>
          <span className="info-label">Gender</span>
          <span className="info-value">{user?.gender || "N/A"}</span>
        </div>

        {/* Whatsapp/Zoom */}
        <div className="info-row" style={{ opacity: isEditingPersonal ? 0.6 : 1 }}>
          <span className="info-label">
            {user?.whatsappZoomValue
              ? user.whatsappZoomValue.includes("@")
                ? "Zoom Email"
                : "WhatsApp Number"
              : "WhatsApp/Zoom Info"}
          </span>
          <span className="info-value">{user?.whatsappZoomValue || "N/A"}</span>
        </div>

        {/* Date Profile Established */}
        <div className="info-row" style={{ opacity: isEditingPersonal ? 0.6 : 1 }}>
          <span className="info-label">Profile Established</span>
          <span className="info-value">{memberSince}</span>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoCard;
